import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'

const columns = [
  { title: 'Id', prop: 'id' },
  { title: 'Created', prop: 'created_at', format: 'dateWithDay' },
  { title: 'Updated', prop: 'updated_at', format: 'dateWithDay' }
]

const filters = []

const defaults = {
  order: [{ column: 'updated_at', direction: 'desc' }]
}

const PrivateCoachings = (props) => (
  <List
    title='Private Coaching'
    apiPath='admin/private_coachings'
    columns={columns}
    filters={filters}
    defaults={defaults}
    buildMenuItems={menuItems}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
  />
)

export default PrivateCoachings
